<template>
  <v-container :class="outerClasses">
    <v-layout>
      <v-flex>
        <v-container fluid py-1 px-0 class="panelContainer">
          <v-layout wrap :style="'padding: 20px 30px 15px 30px; ' + (this.minHeight ? 'min-height: ' + this.minHeight + 'px; ' : '') + panelStyle">
            <v-flex xs12 @click="actionLeftClick" v-if="title && !(titleRight || linkRight)" class="panelTitle" :style="titleStyle">{{ title }}</v-flex>
            <v-flex xs6 @click="actionLeftClick" v-if="title && (titleRight || linkRight)" class="panelTitle" :style="titleStyle">{{ title }}</v-flex>
            <v-flex xs6 text-xs-right v-if="titleRight" class="panelTitle">{{ titleRight }}</v-flex>
            <v-flex xs6 text-xs-right v-if="linkRight" class="panelTitle panelTitleLink"><v-icon @click="linkRightClick">launch</v-icon></v-flex>
            <slot></slot>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Panel',
  props: ['title', 'titleRight', 'minHeight', 'noMargin', 'linkRight', 'actionLeft', 'panelStyle', 'titleSize'],
  computed: {
    outerClasses: function () {
      return this.noMargin === 'true' ? 'container fluid py-2 px-0' : 'container fluid py-2 px-3'
    },
    titleStyle: function () {
      return this.titleSize && this.titleSize !== '' ? 'font-size: ' + this.titleSize + ';' : ''
    }
  },
  methods: {
    linkRightClick: function () {
      this.$router.push({name: this.linkRight})
    },
    actionLeftClick: function () {
      if (this.actionLeft) {
        this.actionLeft()
      }
    }
  }
}
</script>

<style scoped>
  .panelContainer {
    background-color: white;
    border: 1px solid #DDDDDD;
    border-radius: 3px;
  }
  .panelTitle {
    font-weight: bold;
    font-size: 12pt;
    font-style: normal;
    color: #004d40;
    border-bottom: 1px solid #004d40;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Panel.vue